export default function getLink(linkTemplate = '', data: Record<string, any>): string | undefined {
  if (!linkTemplate) return;

  return Object.keys(data).reduce(
    (output: string, key) => output.replace(`{${key}}`, (data[key] ?? '').toString()),
    linkTemplate,
  );
}

export function hasDifferentOrigin(link: string): boolean {
  return !link.includes(window.location.origin);
}
